import { ErrorType } from "~/enums/ErrorType";
import ValidationError from "../validationError";
import NavigableValidator from "./navigableValidator";
import Certificate from "../../../formability/certificateBuilder/models/certificate";

export default class FoundationLayerDependentsValidator extends NavigableValidator<Certificate> {
  defaultType = ErrorType.foundationLayerDependentsWarning;

  protected _validate(model: Certificate): void {
    if (model.hasFoundationLayerDependents) {
      for (const dependent of model.foundation_layer_dependents) {
        const error = this.buildValidationError(model, dependent.id, dependent.title, 'foundation_layer_dependents');
        this.errors.push(error);
      }
    }
  }

  buildValidationError(model: any, value?, displayName?, validatorKey?, type?) {
    const messageFromOptions = this.options.message instanceof Function ? this.options.message(model, validatorKey) : this.options.message
    return new ValidationError({
      message: messageFromOptions || this.defaultMessage,
      displayName: displayName,
      errorNavOpts: this.errorNavOpts(model, validatorKey, value, type),
      field: validatorKey,
      type: this.options.type || type || this.defaultType,
      section: this.section,
      level: this.errorLevel,
    });
  }
}